/*
 * @Author: cc
 * @Date: 2020-02-27 09:40:18
 * @LastEditTime: 2020-02-28 11:34:54
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\directive\supportCreation\directive\loadingPrompt\loadingPromptDirective.js
 * @Description:
 */
'use strict';
angular.module('loadingPromptDirectiveModule', []).directive('loadingPrompt', [
    '$timeout',
    'messagePublishService',
    function($timeout, messagePublishService) {
        return {
            scope: false,
            // scope: {
            //     loading: '=', // 加载中
            //     loadFalse: '=', // 加载失败
            //     loadMore: '=', // 加载更多
            //     items: '=', // 加载列表
            //     itemCount: '=', // 列表总数
            //     loadMoreFalse: '=', // 加载更多失败
            //     more: '&', // 加载更多
            //     retry: '&', // 加载失败重试
            //     noWidth: '=noWidth', // 一些样式的修改
            // },
            restrict: 'E',
            templateUrl: './editingCenter/directive/supportCreation/directive/loadingPrompt/index.html',
            replace: true,
            link: function($scope) {
                initStatus();

                /**
                 * [initStatus description] 初始化状态
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.loadFalse = false;
                    $scope.isShowNoData = true;
                }
                messagePublishService.subscribe(
                    'requetDataFailed',
                    function(event, data) {
                        $scope.loadFalse = true;
                        // 暂定方案，以后要改
                        if ($scope.data.items) {
                            $scope.data.items = [];
                        } else if ($scope.items) {
                            $scope.items = [];
                        }
                        if ($scope.page) {
                            $scope.page.ITEMCOUNT = 0;
                        }
                    },
                    $scope
                ); // 网络请求错误404、503等错误时显示请求失败，而非逻辑错误（200情况但是前后端代码出现报错）

                messagePublishService.subscribe(
                    'changeNoDataStatus',
                    function(event, data) {
                        $scope.isShowNoData = data;
                    },
                    $scope
                ); 

                /**
                 * [retry description] 重新加载
                 * @return  {[type]}  [return description]
                 */
                $scope.retry = function() {
                    $scope.loadFalse = false; // 重试时把状态重置
                    $scope.pageChanged();
                };
                // $scope.$watch('loadMoreFalse', function(nVal) {
                //     if (nVal) {
                //         $timeout(function() {
                //             $scope.loadMoreFalse = false;
                //         }, 1500);
                //     }
                // });
            },
        };
    },
]);
